import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { StaticStorage } from '../static-storage';
import { httpRetry } from '$core/helpers/http-retry';
import { CarouselDataDto } from '../types';

@Injectable({
  providedIn: 'root',
})
export class HomeCarouselService {
  private readonly http = inject(HttpClient);
  private readonly staticStorage = inject(StaticStorage);

  public getHomeCarouselStatics(): Observable<unknown> {
    return this.http.get<unknown>('/v2/carousel-data').pipe(
      httpRetry(5),
      tap((res: CarouselDataDto) => {
        this.staticStorage.updateStatic(res);
      })
    );
  }
}
